import React from "react";
import "./dhipaya_sabaijai.css";

export default function DhipayaSabaijaiDetails({ onQuote }) {
  const rows = [
    { fund: "100,000", type2p: "7,499", type3p: "6,599" },
    { fund: "200,000", type2p: "8,499", type3p: "7,499" },
    { fund: "300,000", type2p: "9,499", type3p: "8,499" },
    { fund: "400,000", type2p: "10,499", type3p: "9,499" },
    { fund: "500,000", type2p: "11,499", type3p: "10,599" },
  ];

  return (
    <div className="pkg-detail dhipaya-sabaijai">
      <h2>ตารางเบี้ย สบายใจชัวร์ 2+ / 3+</h2>
      <p>ครอบคลุม Private Car, Passenger Car, Pickup ≤ 3 ตัน</p>

      <table className="pkg-table">
        <thead>
          <tr>
            <th>ทุนประกันภัย (บาท)</th>
            <th>2+ เบี้ยรวม</th>
            <th>3+ เบี้ยรวม</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.fund}>
              <td>{r.fund}</td>
              <td>{r.type2p}</td>
              <td>{r.type3p}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pkg-foot">
        <p>รวมภาษี / อากร แล้ว • อายุรถไม่เกิน 20 ปี • คุ้มครอง PA 200,000 / รักษา 200,000 / ประกันตัว 300,000</p>
        <button className="pkg-quote-btn" onClick={onQuote}>ขอใบเสนอราคา</button>
      </div>
    </div>
  );
}
